module.exports = __webpack_public_path__ + "img/ico_sup.77571c04.png";